/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Link} from '@ion/core/src/types/entities';
import IdentifierMoreCount from './IdentifierMoreCount';

export interface DeviceTooltipGroupDetailsType {
  itemToDisplay?: Link[];
  setShowDialog?: (showDialog: boolean) => void;
  groupSections?: string;
  groupLength?: number;
  itemLength?: number;
  moreItem?: number;
};

/**
 * Defines the DeviceTooltipGroupDetails component. This component is used to
 * display the group names with tooltip.
 *
 * ```typescript
 *
 *   import DeviceTooltipGroupDetails from './DeviceTooltipGroupDetails';
 *
 *   <DeviceTooltipGroupDetails />
 *
 * ```
 */
const DeviceTooltipGroupDetails = ({
  groupLength,
  groupSections,
  itemToDisplay,
  setShowDialog,
  itemLength,
  moreItem
}: DeviceTooltipGroupDetailsType) => {
  if (groupLength) {
    return (
      <>
        {itemToDisplay?.map?.((group, index) => (
          <div key={index}>
            <span>{group?.title}</span>
          </div>
        ))}
        <IdentifierMoreCount dataSections={groupSections}
          setShowDialog={setShowDialog}
          itemLength={itemLength}
          moreItem={moreItem} />
      </>
    );
  }
  return <div />;
};

export default DeviceTooltipGroupDetails;
